import React from 'react';
import { StyledComponentProps, withStyles, Card } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Delete } from '../../images/icons/delete.svg';

interface IProps extends StyledComponentProps {
    disabled?: boolean;
    text: string;
    onremove: () => any;
}

const DeletableLabelButton = (props: IProps) => {
    return (<Card className={props.classes.btnRootLabelWithIcon}>
        <div className={props.classes.withRightIcon}>
            {props.text}
            {!props.disabled && <div className={props.classes.labelButtonItemIcon}>
                <Delete onClick={props.onremove} style={{ height: '100%' }} />
            </div>}
        </div>
    </Card>)
}


export default withStyles(styles)(DeletableLabelButton)